import React, { useState } from 'react';
import { X, Smartphone } from 'lucide-react';
import useAppLinks from '../hooks/useAppLinks';

const DISMISS_KEY = 'zl_app_banner_dismissed';
const isAndroid = () => typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);

export default function AppDownloadBanner() {
  const links = useAppLinks();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (dismissed || !links?.is_app_banner_active || !links.android_url || !isAndroid()) return null;

  const close = () => { localStorage.setItem(DISMISS_KEY, '1'); setDismissed(true); };

  return (
    <div className="bg-zl-brown-800 text-white px-3 py-2 flex items-center gap-3" data-testid="app-download-banner">
      <button onClick={close} aria-label="Cerrar" className="text-zl-brown-200 hover:text-white transition-colors" data-testid="app-banner-close-btn">
        <X className="w-4 h-4" />
      </button>
      <div className="w-8 h-8 rounded-lg bg-zl-yellow flex items-center justify-center shrink-0">
        <Smartphone className="w-4 h-4 text-zl-brown-800" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold leading-tight truncate">Zona Libre</p>
        <p className="text-[11px] text-zl-brown-200 leading-tight line-clamp-2" data-testid="app-banner-text">{links.banner_text}</p>
      </div>
      <a href={links.android_url} target="_blank" rel="noopener noreferrer"
        className="bg-zl-yellow text-zl-brown-800 text-xs font-bold px-3 py-1.5 rounded-full hover:bg-zl-yellow-400 transition-colors shrink-0"
        data-testid="app-banner-download-btn">
        Descargar
      </a>
    </div>
  );
}
